module.exports = __webpack_public_path__ + "img/trophy-blue.5a4b6a2a.svg";